jQuery(document).ready(function($) {

  // var defaultDogName = 'your pet';
  var defaultDogName = $('h2[data-default-dog-name]').attr('data-default-dog-name');
  $('.quiz_pet_name').text(defaultDogName);

  var quizStep = 1;
  $('.quiz-container li').each(function() {
    $(this).find('[data-step-count]').text(quizStep + ' of ' + $('.quiz-container li').length);
    quizStep++;
  });

  $('.quiz-container').slick({
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    accessibility: false,
    responsive: [{
      breakpoint: 640,
      settings: {
        dots: true,
        arrows: false,
        accessibility: false,
      }
    }]
  });

  $('.button.next').click(function(e) {
    e.preventDefault();
    $('.quiz-container').slick('slickNext');
  });

  $('.whimzees-quiz .whimzees-quiz-input input[type="text"]').keyup(function() {
    if($(this).val() != '') {
      $('#quiz_name_next').prop('disabled', false);
    } else {
      $('#quiz_name_next').prop('disabled', true);
    }
  });

  $('.whimzees-quiz input[name="pet_dental"]').change(function() {
    var petDentalVals = [];
    $('.whimzees-quiz input[name="pet_dental"]').each(function() {
      if($(this).prop('checked')) {
        petDentalVals.push($(this).val());
      }
    });

    if(petDentalVals.length) {
      $('#quiz_dental_next').prop('disabled', false);
    } else {
      $('#quiz_dental_next').prop('disabled', true);
    }
  });

  $(document).on('keypress',function(e) {
    if($('.whimzees-quiz .whimzees-quiz-input input').is(":focus")) {
      if(e.which == 13) { // enter key
        e.preventDefault();
        $('#quiz_name').trigger('change');
        $('.quiz-container').slick('slickNext');
      }
    }
    else {
      var input = $('.whimzees-quiz input[type="radio"]:focus');
      if (input.length) {
        if(e.which == 13) { // enter key
          e.preventDefault();
          $(input).trigger('mouseup');
          $('.quiz-container').slick('slickNext');
        }
      }
    }

  });

  $('.multiple-choice.checkfields input[type="checkbox"]').change(function() {
    var inputUpdate = $(this).parents('.checkfields').attr('data-update-id');
    var checkfieldIDs = [];
    // console.log('checkbox change');

    $(this).parents('.checkfields').find('input[type="checkbox"]').each(function() {
      if($(this).prop('checked')) {
        checkfieldIDs.push($(this).val());
      }
    });

    $('#'+inputUpdate).val(checkfieldIDs.join(','));
    // console.log(checkfieldIDs);
  });

  $('.multiple-choice input[type="radio"], .multiple-choice input[type="checkbox"]').change(function() {
    $('.multiple-choice input[type="radio"], .multiple-choice input[type="checkbox"]').each(function() {
      $(this).siblings('.image-wrapper').toggleClass('selected', $(this).prop('checked'));
    });
  });

  $('.quiz-container input[type="radio"]').on('mouseup', function() {
    $('.quiz-container').slick('slickNext');
  });

  $('.multiple-choice .image-wrapper').click(function() {
    $(this).siblings('input').trigger('click');
  });

  $('a[href=#whimzeesQuiz]').click(function(e) {
    e.preventDefault();
    $('#whimzeesQuiz').foundation('open');
    $('.quiz-container').slick("refresh");
  });

  $('.multiple-choice .image-wrapper').click(function() {
    $(this).siblings('input[type="radio"]').trigger('mouseup');
    // console.log('bloop');
  });

  $('#quiz_name').change(function() {
    if($('#quiz_name').val().length) {
      $('.quiz_pet_name').text($('#quiz_name').val());
    } else {
      $('.quiz_pet_name').text(defaultDogName);
    }
  });

  $('#treat-quiz').submit(function(e) {
    e.preventDefault();
    e.returnValue = false;

    $('.loading-cover').addClass('show');

    var $form = $(this);

    // only email if language is english
    if($('#treat-quiz input[name="lang"]').length) {
      $form.off('submit');
      $form.submit();
    } else {

      var quizAnswers = [];

      // Dog Name
      quizAnswers.push({
        question: $('#quiz_name_q').text(),
        answer: $('#quiz_name').val(),
      });

      // Dental Treat
      var petDentalVals = [];
      $('.whimzees-quiz input[name="pet_dental"]').each(function() {
        if($(this).prop('checked')) {
          petDentalVals.push($('label[for="'+$(this).attr('id')+'"]').text());
        }
      });
      quizAnswers.push({
        question: $('#pet_dental_q').text(),
        answer: petDentalVals.join(', '),
      });

      // Life Stage
      quizAnswers.push({
        question: $('#life_stage_q').text(),
        answer: $('label[for="'+$('input[name="life_stage"]:checked').attr('id')+'"]').text(),
      });

      // Dog Size
      quizAnswers.push({
        question: $('#dog_sizes_q').text(),
        answer: $('label[for="'+$('input[name="dog_sizes"]:checked').attr('id')+'"]').text(),
      });

      // Treat Shape
      quizAnswers.push({
        question: $('#formula_q').text(),
        answer: $('label[for="'+$('input[name="formula"]:checked').attr('id')+'"]').text(),
      });

      console.log(quizAnswers);

      // $.ajax({
      //   type: "POST",
      //   url: "/wp-admin/admin-ajax.php",
      //   context: $form,
      //   datatype: "html",
      //     data: {'action': 'quiz_sending_mail', 'quizAnswers': quizAnswers},
      //   success: function(response) {

      //   },error:function(response){
      //       console.log("error: " + response);
      //   },
      //   complete: function() {
      //     this.off('submit');
      //     this.submit();
      //   }
      // });

      $form.off('submit');
      $form.submit();

    }
  });

});
